(($) => {

    "use strict";

    $.enhancer("getDynamicHeight", function () {
        var _this = $(this);
        
        if (!$(this).hasClass("show") && $(this).children().length > 0 ) {
            var heightToNth = $(this).children().eq(4).offset().top;
            var parentoffset = $(this).offset().top;
            var elHeight = heightToNth - parentoffset;
            $(this).height( elHeight );   
        } else if ($(this).children().length > 0) {
            $(this).height("auto");
        }

        $(this).next(".reveal-content-btn").on("click",
            function () {
                if (!$(this).hasClass("show")) {
                    var heightToNth = $(_this).children().eq(4).offset().top;
                    var parentoffset = $(_this).offset().top;
                    var elHeight = heightToNth - parentoffset;
                    $(_this).height( elHeight );
                } else {
                    $(_this).height( "auto" );
                }
               
            }
        );
    });

})(jQuery);